import {
  FETCH_GRADE_FAILURE,
  FETCH_GRADE_LOADING,
  FETCH_GRADE_SUCCESS,
  ADD_GRADE_FAILURE,
  ADD_GRADE_SUCCESS,
  ADD_GRADE_LOADING,
  UPDATE_GRADE_FAILURE,
  UPDATE_GRADE_LOADING,
  UPDATE_GRADE_SUCCESS,
  DELETE_GRADE_FAILURE,
  DELETE_GRADE_LOADING,
  DELETE_GRADE_SUCCESS
} from '../Types/gradeTypes';
import api from '../config/api';

const API_WP = process.env.REACT_APP_API_URL;
export const getGrades = () => {
  return dispatch => {
    dispatch({
      type: FETCH_GRADE_LOADING
    });
    api
      .get(`${API_WP}Grade`)
      .then(response => {
        const { data } = response.data;
        dispatch(fetchGradesSuccess(data));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch(fetchGradesError(errorMsg));
      });
  };
};

export const getGradeByID = id => {
  return dispatch => {
    dispatch({
      type: FETCH_GRADE_LOADING
    });
    api
      .get(`${API_WP}Grade/search/${id}`)
      .then(response => {
        const { data } = response.data;
        dispatch(fetchGradesSuccess(data));
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch(fetchGradesError(errorMsg));
      });
  };
};
export const addGrade = gradeData => {
  return dispatch => {
    dispatch({ type: ADD_GRADE_LOADING });
    api
      .post(`${API_WP}Grade/add`, gradeData)
      .then(response => {
        console.log('response.data.data', response.data.data);
        dispatch({
          type: ADD_GRADE_SUCCESS,
          payload: response.data.data
        });
        // dispatch(getGrades());
      })
      .catch(error => {
        dispatch({
          type: ADD_GRADE_FAILURE,
          payload: error.message
        });
      });
  };
};
export const updateGrade = (id, gradeData) => {
  return dispatch => {
    dispatch({ type: UPDATE_GRADE_LOADING });
    api
      .put(`${API_WP}Grade/update/${id}`, gradeData)
      .then(response => {
        dispatch({
          type: UPDATE_GRADE_SUCCESS,
          payload: response.data.data
        });

        dispatch(getGrades());
      })
      .catch(error => {
        dispatch({
          type: UPDATE_GRADE_FAILURE,
          payload: error.message
        });
      });
  };
};
export const removeGrade = id => {
  return dispatch => {
    dispatch({ type: DELETE_GRADE_LOADING });
    api
      .delete(`${API_WP}Grade/remove/${id}`)
      .then(response => {
        dispatch({
          type: DELETE_GRADE_SUCCESS,
          payload: id
        });
        // dispatch(getGrades());
      })
      .catch(error => {
        dispatch({
          type: DELETE_GRADE_FAILURE,
          payload: error.message
        });
      });
  };
};

export const fetchGradesLoading = () => {
  return {
    type: FETCH_GRADE_LOADING,
    payload: []
  };
};

export const fetchGradesSuccess = data => {
  return {
    type: FETCH_GRADE_SUCCESS,
    payload: data
  };
};

export const fetchGradesError = error => {
  return {
    type: FETCH_GRADE_FAILURE,
    payload: error
  };
};
